var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',[_c('template',{slot:"start"},[_c('b-navbar-item',{attrs:{"href":"#"}},[_vm._v(" Start ")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }